export const CREATE_CAMPAIGN_SCREEN = {
  CAMPAIGN_SETUP: 'Campaign Setup',
  AUDIENCE: 'Audience',
  COMPOSE: 'Compose',
  PREVIEW_CAMPAIGN: 'Preview Campaign',
  NEXT: 'Next',
  CAMPAIGN_NAME: 'Campaign Name',
  SCHEDULE: 'Schedule',
  EDIT: 'Edit',
  CANCEL: 'Cancel',
  USE_EXISTING_VALUE: 'use_existing',
  CREATE_NEW_VALUE: 'create_new',
  AUDIENCE_SELECTION: 'Audience Selection',
  CREATE_NEW: 'Create new',
  SELECT_STORES: 'Select stores',
  USE_EXISTING: 'Use existing',
  SAVE_AUDIENCE_TEMPLATE: 'Save audience template',
  LIVE_PREVIEW: 'Live preview',
  COMPOSE_NEW: 'Compose new',
  TEMPLATES: 'Templates',
  MESSAGE: 'Message',
  CHARACTER_COUNT: 'Character count: ',
  BILLABLE_CREDITS: 'Billable credits: ',
  TEST_USER: 'Test user',
  SELECT_TEST_USER: 'Select Test User',
  SEND_TO_TEST_USERS: 'Send to test users',
  NEXT_SEND_TIME: 'Next Send Time',
  SELECTED_AUDIENCE: 'Selected audience',
  PREVIEW_MESSAGE: 'Preview Message',
  SEND_TIME: 'Send Time',
  NEXT_SEND_TIME_AT: 'Next send time: ',
  CREDIT_COST: 'Credit Cost',
  CREDIT_COST_INFO:
    'Credit cost is equal to Estimated Audience* Cost per message',
  CAMPAIGN_SETUP_TAB_KEY: 'campaign-setup',
  AUDIENCE_TAB_KEY: 'audience',
  COMPOSE_TAB_KEY: 'compose',
  PREVIEW_CAMPAIGN_TAB_KEY: 'preview-campaign',
  CHOOSE_ATTRIBUTE: 'Choose attribute',
  CHOOSE_OPERATOR: 'Choose operator',
  ARRAY_ATTR_TYPE: 'Array',
  STRING_ATTR_TYPE: 'String',
  BOOLEAN_ATTR_TYPE: 'Boolean',
  NUMERIC_ATTR_TYPE: 'Numeric',
  TIME_ATTR_TYPE: 'Time',
  CHOOSE_VALUE: 'Choose value',
};
